import { formatAmount } from '@utils/helpers';
import { Party } from 'interfaces/party.interface';
import React, { useEffect, useState } from 'react';
import defaultAvatar from '@assets/default-avatar/9.png';
import Icon from '@components/ui/icon';
import './party.css';
import { RootState } from '@redux/store';
import { useSelector } from 'react-redux';
import { canJoinParty } from '@utils/game.util';
import { useAuth } from '@hooks/use-auth';
import { Player } from 'interfaces/player.interface';
// Notice here we're using the function declaration with the interface Props
export interface PartyWidgetProps {
    party: Party;
    isPendingPart?: boolean;
    onSelectGame?: (game: Party) => void;
}

const PartyWidget: React.FunctionComponent<PartyWidgetProps> = ({
    party,
    isPendingPart,
    onSelectGame,
}: PartyWidgetProps) => {
    const { blocked_gamers } = useSelector((state: RootState) => state.blockGamerStore);
    const nbPlayers = party.players ? party.players.length : '-';
    const [creator, setCreator] = useState<Player>();

    const { user } = useAuth();

    const handleClick = () => {
        onSelectGame?.(party);
    };

    const getSpecialClass = () => {
        let clazz = '';
        if (party.is_competition) {
            clazz = 'is-competition';
        } else if (isPendingPart && !canJoinParty(party, user?.balance ?? 0)) {
            clazz = 'cannot-join';
        } else if (
            blocked_gamers &&
            party.bet != 0 &&
            party.max_nb_players > 1 &&
            blocked_gamers.find((item) => item.id == party.creator_id)
        ) {
            clazz = 'blocked-user';
        }
        return clazz;
    };

    useEffect(() => {
        const _creator = party.players.find((player: Player) => player.user_id == party.creator_id);
        setCreator(_creator);
    }, [party]);

    return (
        <div className={`widget special-widget opaced game-card ${getSpecialClass()}`} onClick={handleClick}>
            <div className="widget-body">
                <div className="creator-infos">
                    <div className="user-avatar">
                        <img src={defaultAvatar} alt="" />
                    </div>
                </div>
                <div>
                    <div className="card-title space-between">
                        <div className="creator-infos">
                            <span className="party-amount">{party.bet ? formatAmount(party.bet) : '0'} F</span>
                            <span className="party-pseudo">{party.is_competition ? party.title : creator?.pseudo}</span>
                        </div>
                    </div>
                    <div className="join-infos mt-2">
                        <div className="game-infos">
                            <div className="info">
                                <span className="icon icon16">
                                    <svg
                                        width="18"
                                        height="14"
                                        viewBox="0 0 18 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M5.5 1.75C5.77614 1.75 6 1.52614 6 1.25C6 0.973858 5.77614 0.75 5.5 0.75V1.75ZM5.5 6.11364C5.77614 6.11364 6 5.88978 6 5.61364C6 5.33749 5.77614 5.11364 5.5 5.11364V6.11364ZM4.53415 8.26989C4.79593 8.18199 4.93689 7.89852 4.84899 7.63674C4.7611 7.37497 4.47763 7.23401 4.21585 7.3219L4.53415 8.26989ZM1 12.1102L0.5 12.1095V12.1102H1ZM1 13.2504H0.5C0.5 13.5266 0.723858 13.7504 1 13.7504V13.2504ZM2.74569 13.7504C3.02183 13.7504 3.24569 13.5266 3.24569 13.2504C3.24569 12.9743 3.02183 12.7504 2.74569 12.7504V13.7504ZM13.5 13.25V13.75C13.7761 13.75 14 13.5261 14 13.25H13.5ZM4.5 13.25H4C4 13.5261 4.22386 13.75 4.5 13.75V13.25ZM4.5 12.25H4H4.5ZM9 7.75V7.25V7.75ZM12.5 0.75C12.2239 0.75 12 0.973858 12 1.25C12 1.52614 12.2239 1.75 12.5 1.75V0.75ZM12.5 5.25C12.2239 5.25 12 5.47386 12 5.75C12 6.02614 12.2239 6.25 12.5 6.25V5.25ZM14.2779 7.4731C14.0198 7.37492 13.731 7.50455 13.6328 7.76265C13.5346 8.02075 13.6642 8.30957 13.9223 8.40776L14.2779 7.4731ZM17.0001 12.1404H17.5001V12.1398L17.0001 12.1404ZM17.0001 13.2504V13.7504C17.2762 13.7504 17.5001 13.5266 17.5001 13.2504H17.0001ZM15.5001 12.7504C15.224 12.7504 15.0001 12.9743 15.0001 13.2504C15.0001 13.5266 15.224 13.7504 15.5001 13.7504V12.7504ZM5.5 0.75C4.77553 0.75 4.07776 1.02893 3.56094 1.53009L4.25708 2.24799C4.58417 1.93081 5.03099 1.75 5.5 1.75V0.75ZM3.56094 1.53009C3.04359 2.03176 2.75 2.7155 2.75 3.43182H3.75C3.75 2.99082 3.93052 2.56466 4.25708 2.24799L3.56094 1.53009ZM2.75 3.43182C2.75 4.14813 3.04359 4.83188 3.56094 5.33355L4.25708 4.61565C3.93052 4.29897 3.75 3.87281 3.75 3.43182H2.75ZM3.56094 5.33355C4.07776 5.83471 4.77553 6.11364 5.5 6.11364V5.11364C5.03099 5.11364 4.58417 4.93282 4.25708 4.61565L3.56094 5.33355ZM4.21585 7.3219C3.13844 7.68367 2.20087 8.32893 1.53368 9.18181L2.32131 9.79795C2.85945 9.11004 3.62884 8.57387 4.53415 8.26989L4.21585 7.3219ZM1.53368 9.18181C0.865679 10.0357 0.501578 11.0566 0.500001 12.1095L1.5 12.111C1.50123 11.2914 1.78399 10.4848 2.32131 9.79795L1.53368 9.18181ZM0.5 12.1102V13.2504H1.5V12.1102H0.5ZM1 13.7504H2.74569V12.7504H1V13.7504ZM10.75 3.5C10.75 4.4665 9.9665 5.25 9 5.25V6.25C10.5188 6.25 11.75 5.01878 11.75 3.5H10.75ZM9 5.25C8.0335 5.25 7.25 4.4665 7.25 3.5H6.25C6.25 5.01878 7.48122 6.25 9 6.25V5.25ZM7.25 3.5C7.25 2.5335 8.0335 1.75 9 1.75V0.75C7.48122 0.75 6.25 1.98122 6.25 3.5H7.25ZM9 1.75C9.9665 1.75 10.75 2.5335 10.75 3.5H11.75C11.75 1.98122 10.5188 0.75 9 0.75V1.75ZM13.5 12.75H4.5V13.75H13.5V12.75ZM5 13.25V12.25H4V13.25H5ZM5 12.25C5 11.1891 5.42143 10.1717 6.17157 9.42157L5.46447 8.71447C4.52678 9.65215 4 10.9239 4 12.25H5ZM6.17157 9.42157C6.92172 8.67143 7.93913 8.25 9 8.25V7.25C7.67392 7.25 6.40215 7.77678 5.46447 8.71447L6.17157 9.42157ZM9 8.25C10.0609 8.25 11.0783 8.67143 11.8284 9.42157L12.5355 8.71447C11.5979 7.77678 10.3261 7.25 9 7.25V8.25ZM11.8284 9.42157C12.5786 10.1717 13 11.1891 13 12.25H14C14 10.9239 13.4732 9.65215 12.5355 8.71447L11.8284 9.42157ZM13 12.25V13.25H14V12.25H13ZM12.5 1.75C12.9641 1.75 13.4092 1.93437 13.7374 2.26256L14.4445 1.55546C13.9288 1.03973 13.2293 0.75 12.5 0.75V1.75ZM13.7374 2.26256C14.0656 2.59075 14.25 3.03587 14.25 3.5H15.25C15.25 2.77065 14.9603 2.07118 14.4445 1.55546L13.7374 2.26256ZM14.25 3.5C14.25 3.96413 14.0656 4.40925 13.7374 4.73744L14.4445 5.44454C14.9603 4.92882 15.25 4.22935 15.25 3.5H14.25ZM13.7374 4.73744C13.4092 5.06563 12.9641 5.25 12.5 5.25V6.25C13.2293 6.25 13.9288 5.96027 14.4445 5.44454L13.7374 4.73744ZM13.9223 8.40776C14.6795 8.6958 15.3314 9.20697 15.7917 9.87362L16.6146 9.30543C16.0392 8.47212 15.2244 7.83316 14.2779 7.4731L13.9223 8.40776ZM15.7917 9.87362C16.252 10.5403 16.499 11.331 16.5001 12.1411L17.5001 12.1398C17.4988 11.1271 17.19 10.1387 16.6146 9.30543L15.7917 9.87362ZM16.5001 12.1404V13.2504H17.5001V12.1404H16.5001ZM17.0001 12.7504H15.5001V13.7504H17.0001V12.7504Z"
                                            fill="#E6E6E6"
                                        />
                                    </svg>
                                </span>
                                <span className="value">
                                    {nbPlayers}
                                    {isPendingPart ? '/' + (party.max_nb_players + 1) : ''}
                                </span>
                            </div>
                            <div className="info">
                                <span className="icon icon16">
                                    <svg
                                        width="12"
                                        height="12"
                                        viewBox="0 0 13 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M10 4.25C10 5.17826 9.63125 6.0685 8.97487 6.72487C8.3185 7.38125 7.42826 7.75 6.5 7.75C5.57174 7.75 4.6815 7.38125 4.02513 6.72487C3.36875 6.0685 3 5.17826 3 4.25V1.25H10V4.25Z"
                                            stroke="#E6E6E6"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M10 11.25C10 10.3217 9.63125 9.4315 8.97487 8.77513C8.3185 8.11875 7.42826 7.75 6.5 7.75C5.57174 7.75 4.6815 8.11875 4.02513 8.77513C3.36875 9.4315 3 10.3217 3 11.25V14.25H10V11.25Z"
                                            stroke="#E6E6E6"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M1 1.25H12"
                                            stroke="#E6E6E6"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M1 14.75H12"
                                            stroke="#E6E6E6"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </span>
                                <span className="value">{party.time_per_move}</span>
                            </div>
                            {party.special_mode && (
                                <div className="info">
                                    <fieldset className="d-flex flex-row align-items-center gap-4 py-1">
                                        <Icon name={'settings'} className="special-mode-icon"></Icon>
                                    </fieldset>
                                </div>
                            )}
                            <div className="info">
                                <div className="d-flex align-items-center gap-1 awaiting-g-bet">
                                    {party.korat && !party.double_korat && <span className="value">K</span>}
                                    {party.double_korat && <span className="value">2K x4</span>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {party.password.length == 0 && (
                <span className="timer public-party-unlock">
                    <Icon name="unlock" color="white" />
                </span>
            )}
            {party.password.length > 0 && (
                <span className="timer private-party-lock">
                    <Icon name="lock" color="white" />
                </span>
            )}
        </div>
    );
};

export default PartyWidget;
